import { AdminRuntimeQueueStats } from "./AdminRuntimeQueueStats"
import { AdminRuntimeTimerStats } from "./AdminRuntimeTimerStats"

export class AdminRuntimeStats {
  capturedAtUtc: string

  machineName: string

  operatingSystem: string

  processorCount: number

  processUptimeSeconds: number

  processCpuUsagePercent: number

  processAverageLoadPerCorePercent: number

  processThreadCount: number

  processPrivateMemoryBytes: number

  processWorkingSetBytes: number

  gcTotalMemoryBytes: number

  totalPhysicalMemoryBytes: number

  availablePhysicalMemoryBytes: number

  physicalMemoryUsagePercent: number

  processMemoryUsagePercent: number

  availableMemoryBytes: number

  storageMountPoint: string

  storageTotalBytes: number

  storageFreeBytes: number

  storageUsedBytes: number

  storageUsagePercent: number

  estimatedActiveOperatorsLast5Minutes: number

  openOrdersInFlow: number

  pendingOrdersInFlow: number

  preparingOrdersInFlow: number

  inDeliveryOrdersInFlow: number

  alerts: string[]

  queues: AdminRuntimeQueueStats[]

  timers: AdminRuntimeTimerStats[]


  constructor(data: Partial<AdminRuntimeStats> = {}) {
    this.capturedAtUtc = data.capturedAtUtc ?? ""

    this.machineName = data.machineName ?? ""

    this.operatingSystem = data.operatingSystem ?? ""

    this.processorCount = data.processorCount ?? 0

    this.processUptimeSeconds = data.processUptimeSeconds ?? 0

    this.processCpuUsagePercent = data.processCpuUsagePercent ?? 0

    this.processAverageLoadPerCorePercent = data.processAverageLoadPerCorePercent ?? 0

    this.processThreadCount = data.processThreadCount ?? 0

    this.processPrivateMemoryBytes = data.processPrivateMemoryBytes ?? 0

    this.processWorkingSetBytes = data.processWorkingSetBytes ?? 0

    this.gcTotalMemoryBytes = data.gcTotalMemoryBytes ?? 0

    this.totalPhysicalMemoryBytes = data.totalPhysicalMemoryBytes ?? 0

    this.availablePhysicalMemoryBytes = data.availablePhysicalMemoryBytes ?? 0

    this.physicalMemoryUsagePercent = data.physicalMemoryUsagePercent ?? 0

    this.processMemoryUsagePercent = data.processMemoryUsagePercent ?? 0

    this.availableMemoryBytes = data.availableMemoryBytes ?? 0

    this.storageMountPoint = data.storageMountPoint ?? "-"

    this.storageTotalBytes = data.storageTotalBytes ?? 0

    this.storageFreeBytes = data.storageFreeBytes ?? 0

    this.storageUsedBytes = data.storageUsedBytes ?? 0

    this.storageUsagePercent = data.storageUsagePercent ?? 0

    this.estimatedActiveOperatorsLast5Minutes = data.estimatedActiveOperatorsLast5Minutes ?? 0

    this.openOrdersInFlow = data.openOrdersInFlow ?? 0

    this.pendingOrdersInFlow = data.pendingOrdersInFlow ?? 0

    this.preparingOrdersInFlow = data.preparingOrdersInFlow ?? 0

    this.inDeliveryOrdersInFlow = data.inDeliveryOrdersInFlow ?? 0

    this.alerts = data.alerts ?? []

    this.queues = (data.queues ?? []).map((item) => new AdminRuntimeQueueStats(item))

    this.timers = (data.timers ?? []).map((item) => new AdminRuntimeTimerStats(item))

  }
}
